import React from 'react';

export default function MousePointer() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.7142 10.714L13.5429 13.5427M4.79219 1.49268L5.31019 3.42401M3.42419 5.31001L1.49219 4.79201M9.30019 2.70001L7.88552 4.11468M4.11419 7.88534L2.70085 9.30001M6.00016 6L9.3335 14L10.5162 10.516L14.0002 9.33333L6.00016 6Z'
        stroke='url(#paint0_linear_1658_918)'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1658_918'
          x1='1.39554'
          y1='-1.07717'
          x2='10.4748'
          y2='12.2314'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0.65' />
        </linearGradient>
      </defs>
    </svg>
  );
}
